export default __webpack_public_path__ + "static/cedar-e2654f3d9f122efb1a1a91944c4202b5.svg";